import { utils, Contract } from 'ethers';

/* Autogenerated file. Do not edit manually. */
var _abi = [{
  inputs: [{
    internalType: "address",
    name: "_stakingContract",
    type: "address"
  }, {
    internalType: "address",
    name: "_owner",
    type: "address"
  }, {
    internalType: "address",
    name: "_previousOwner",
    type: "address"
  }],
  name: "assignOwnerToContract",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_caller",
    type: "address"
  }, {
    internalType: "bool",
    name: "_value",
    type: "bool"
  }],
  name: "setCaller",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
var IStakingRegistry__factory = /** @class */function () {
  function IStakingRegistry__factory() {}
  IStakingRegistry__factory.createInterface = function () {
    return new utils.Interface(_abi);
  };
  IStakingRegistry__factory.connect = function (address, signerOrProvider) {
    return new Contract(address, _abi, signerOrProvider);
  };
  IStakingRegistry__factory.abi = _abi;
  return IStakingRegistry__factory;
}();

export { IStakingRegistry__factory };
